import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "./services/common.service";
import { EmbedCodeService } from "./services/embed-code.service";
import { SiteService } from "./services/site.service";
import { AffiliateService } from "./services/affiliate.service";
import { AnalyticsService } from "./services/analytics.service";
/* LOAD STATIC DEFAULT LANGUAGE */
import defaultLanguage from "./../assets/i18n/ja.json";

@Component({
  selector: "app-busbookmark",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  public embedCodeHeader: any = "";
  public embedCodeBody: any = "";
  public timeoutFuncPageLoader: any;
  public $: any;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public embedCodeService: EmbedCodeService,
    public siteService: SiteService,
    private translate: TranslateService,
    private affiliateService: AffiliateService,
    private analyticsService: AnalyticsService
  ) {
    /* INIT DEFAULT LANGUAGE FOR TRANSLATION */
    translate.setTranslation("ja", defaultLanguage);
    translate.setDefaultLang("ja");

    this.analyticsService.init();

    let self = this;
    this.$ = this.commonService.getJQuery();

    /* SET TRACKING EVENT BY ROUTE */
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        /* WHEN THE ROUTE STOPS */

        let currentURL = event.urlAfterRedirects
          ? event.urlAfterRedirects
          : event.url;

        this.analyticsService.pageView(currentURL);

        /* IS HOME PAGE (TOP PAGE) */
        if (currentURL == "/") {
          this.embedCodeService.googleTagHomeHeaderSet();
          this.embedCodeService.yahooTagBodySet();

          /* IS FINISH RESERVATION PAGE */
        } else if (
          currentURL == this.commonService.routePaths.pageReserveFinishNoParam
        ) {
          /* DO NOTHING */
          /* CUSTOM TRACKING IN reserve/finish COMPONENT */
          /* ALL PAGES REST */
        } else {
          this.embedCodeService.yahooTagBodySet();
        }

        /* EXECUTE JS */
        /* this.$("#embedCodeHeader").empty().html(this.embedCodeHeader);
                this.$("#embedCodeBody").empty().html(this.embedCodeBody); */

        /* GET AFFILIATE CODE & REFERRER */
        let acdCode = this.activatedRoute.snapshot.queryParams.acd;
        /* SAVE AFFILIATE CODE */
        if (acdCode) {
          this.affiliateService.saveAcdCode(acdCode);
        }
        this.setupAffiliate(currentURL);

        /* CLOSE ALL MODALS WHEN ROUTE CHANGE */
        this.commonService.closeAllModals();

        /* CLEAR PAGE LOADER IF PAGE IS LOADED AFTER 50 SECONDS */
        window.clearTimeout(
          this.timeoutFuncPageLoader
        ); /* CLEAR PREVIOUS PAGE LOADER TIMEOUT */
        this.timeoutFuncPageLoader = window.setTimeout(function () {
          self.commonService.hidePageLoader();
        }, 50000);
      }
    });

    /* REFERRER */
    let referrer = String(document.referrer);
    if (
      referrer &&
      referrer.indexOf(this.commonService.appConfig.productionDomain) === -1
    ) {
      this.commonService.setData(
        this.commonService.appConfig.plan.referrerSessionName,
        { referrer: referrer }
      );
    }
  }

  async ngOnInit() {
    /* GET BUS CONFIGS & STORE THEM */
    const busSettings = await this.siteService.getBusSettings();
    if (busSettings) {
      this.commonService.setData(
        this.commonService.appConfig.site.settingSessionName,
        busSettings
      );
    }
  }

  ngAfterViewInit() {
    /* HIDE PAGE LOADING */
    this.commonService.hidePageLoader();
  }

  setupAffiliate(currentURL: string) {
    if (currentURL == this.commonService.routePaths.pageReserveFinishNoParam) {
      return;
    }

    let acdCode = this.affiliateService.getAcdCode();
    if (!acdCode) {
      this.$("#embedAffiliateCode").empty();
      return;
    }
    acdCode = acdCode.code.toLowerCase();
    if (acdCode === "afb") {
      const embedCode = this.affiliateService.getEmbedAFBCodeLP();
      this.$("#embedAffiliateCode").empty().append(embedCode);
    } else if (acdCode === "ari") {
      const embedCode = this.affiliateService.getEmbedARICodeLP();
      this.$("#embedAffiliateCode").empty().append(embedCode);
    }
  }
}
